/* Shubha cart drawer: coupon apply/remove */
(function () {
  'use strict';
  if (window.__shubhaCoupon) return;
  window.__shubhaCoupon = true;
  function refresh() {
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return Promise.resolve(); }
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      try { if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) window.sharedFunctions.updateSidebarCart(cart); } catch (e) {}
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      return cart;
    });
  }
  function setCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-sc-coupon]'); if (!f) return;
    e.preventDefault();
    apply(f);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sc-apply]'); if (!b) return;
    e.preventDefault();
    apply(b.closest('[data-sc-coupon]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var f = e.target.closest && e.target.closest('[data-sc-coupon]');
    if (!f || f.tagName === 'FORM') return;
    e.preventDefault();
    apply(f);
  });
  function variants(raw) {
    var t = raw.trim(), out = [];
    [t, t.toUpperCase(), t.toLowerCase(), t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()].forEach(function (c) { if (c && out.indexOf(c) < 0) out.push(c); });
    return out;
  }
  function apply(f) {
    if (!f) return;
    var input = f.querySelector('input'), btn = f.querySelector('button'), msg = f.querySelector('[data-sc-coupon-msg]');
    var raw = (input.value || '').trim();
    if (!raw) { msg.textContent = 'Please enter a coupon code.'; msg.className = 'sc-coupon__msg is-err'; return; }
    var key = raw.toUpperCase(), tries = variants(raw), others = [];
    btn.setAttribute('aria-busy', 'true'); msg.textContent = ''; msg.className = 'sc-coupon__msg';
    function attempt(i) {
      if (i >= tries.length) {
        return setCodes(others).then(function () {
          msg.textContent = 'Coupon "' + raw + '" is not valid for the items in your cart or this order value.';
          msg.className = 'sc-coupon__msg is-err';
          btn.removeAttribute('aria-busy');
        });
      }
      return setCodes(others.concat([tries[i]])).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === key && d.applicable; })[0];
        if (hit) { try { localStorage.setItem('storedDiscount', hit.code); } catch (err) {} return refresh(); }
        return attempt(i + 1);
      });
    }
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      others = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c.toUpperCase() !== key; });
      return attempt(0);
    }).catch(function () {
      msg.textContent = 'Could not apply the coupon. Please try again.'; msg.className = 'sc-coupon__msg is-err';
      btn.removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sc-remove-code]'); if (!b) return;
    e.preventDefault();
    var code = b.getAttribute('data-sc-remove-code').toUpperCase();
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      return setCodes((cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c.toUpperCase() !== code; }));
    }).then(function () { try { localStorage.removeItem('storedDiscount'); } catch (err) {} return refresh(); });
  });

  /* Checkout buttons (drawer + cart page): straight to Shopify checkout, like Buy Now.
     Runs in the window capture phase so no other script can redirect the click. */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sh-go-checkout]'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.disabled || b.getAttribute('aria-busy') === 'true') return;
    var real = document.getElementById('sh-cart-go');
    if (real && real.disabled && b !== real) { real.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    /* Razorpay Magic Checkout. Its checkout is ready once openRzpCheckout and window.Razorpay both exist.
       Tapped before that (slow network, or the home page where it loads on the first tap): show "Loading secure
       checkout...", wait for it, then tap the same button again for the shopper. Shopify checkout is used only
       if Razorpay never loads (for example blocked by an ad blocker). */
    function rzpReady() { return typeof window.openRzpCheckout === 'function' && typeof window.Razorpay === 'function'; }
    if (rzpReady()) {
      b.setAttribute('aria-busy', 'true');
      setTimeout(function () { b.removeAttribute('aria-busy'); }, 4000);
      try { window.openRzpCheckout(e); return; } catch (err) {}
      window.location.href = '/checkout'; return;
    }
    var rzpOnPage = !!document.querySelector('script[src*="razorpay"]') || !!document.getElementById('sh-rzp-tpl');
    if (!rzpOnPage) { window.location.href = '/checkout'; return; }
    if (window.shLazyStart) window.shLazyStart(); /* Razorpay loads on the first interaction; make sure it has started */
    b.setAttribute('aria-busy', 'true');
    var label = b.innerHTML, waited = 0;
    b.textContent = 'Loading secure checkout...';
    (function wait() {
      if (rzpReady()) { setTimeout(function () { b.innerHTML = label; b.removeAttribute('aria-busy'); b.click(); }, 300); return; }
      if ((waited += 150) < 10000) { setTimeout(wait, 150); return; }
      b.innerHTML = label; b.removeAttribute('aria-busy'); window.location.href = '/checkout';
    })();
  }, true);

  /* Quantity: when Shopify gives less than asked (stock limit), say so and show the real number */
  /* small note right under the quantity box (drawer and cart page) */
  function note(input, text) {
    if (!input) return;
    var row = input.closest('.sc-item__row, .cart-item-qty, .cart-item-quantity, .previewCartItem-change') || input.parentElement;
    var host = row.parentElement, el = host.querySelector(':scope > .sc-stock-msg');
    if (!el) { el = document.createElement('p'); el.className = 'sc-stock-msg'; el.setAttribute('role', 'status'); row.insertAdjacentElement('afterend', el); }
    el.textContent = text;
    clearTimeout(el.__t); el.__t = setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 4000);
  }
  function stockText(n) { return n > 0 ? 'Only ' + n + ' piece' + (n > 1 ? 's' : '') + ' available right now.' : 'This item is out of stock.'; }
  /* plus button: stop at the stock we know about and say why */
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('[data-plus-quantity-cart]'); if (!plus) return;
    var input = plus.parentElement && plus.parentElement.querySelector('input.quantity, input[name="quantity"]'); if (!input) return;
    var max = parseInt(input.getAttribute('data-inventory-quantity'), 10), val = parseInt(input.value, 10) || 0;
    if (max > 0 && val >= max) { e.preventDefault(); e.stopImmediatePropagation(); note(input, stockText(max)); }
  }, true);
  function checkChange(body) {
    var want = parseInt(body.quantity, 10); if (!(want > 0)) return;
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var item = null;
      if (body.line) item = cart.items[parseInt(body.line, 10) - 1];
      else if (body.id) item = cart.items.filter(function (i) { return i.key === body.id || String(i.id) === String(body.id) || String(i.variant_id) === String(body.id); })[0];
      if (!item || item.quantity >= want) return;
      var got = item.quantity;
      function fix() {
        var shown = false;
        document.querySelectorAll('input[data-cart-quantity-id="' + item.id + '"], input[data-line="' + item.key + '"]').forEach(function (inp) {
          inp.value = got; inp.setAttribute('data-inventory-quantity', got);
          if (inp.offsetParent && !shown) { note(inp, stockText(got)); shown = true; }
        });
      }
      fix(); setTimeout(fix, 700);
    }).catch(function () {});
  }
  /* hide the theme's yellow "Only X items were added ... due to availability" bar: the red note under the quantity box says it instead */
  function quietStockWarnings() {
    var o = window.showWarning;
    if (typeof o !== 'function' || o.__sh) return;
    var w = function (content) {
      if (/due to availability|only \d+ (item|piece)|maximum available|already have the maximum|can't add more|cannot add more|out of stock/i.test(String(content || ''))) { document.body.classList.remove('has-warning'); return; }
      return o.apply(this, arguments);
    };
    w.__sh = true; window.showWarning = w;
  }
  quietStockWarnings();
  document.addEventListener('DOMContentLoaded', quietStockWarnings);
  window.addEventListener('load', quietStockWarnings);
  if (window.fetch && !window.__shQtyHook) {
    window.__shQtyHook = true;
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/change(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var body = null; try { body = JSON.parse(init.body); } catch (e) {}
        if (body) p.then(function () { checkChange(body); }, function () { checkChange(body); });
      }
      return p;
    };
  }

  /* Cart page: remove a product in place (no page refresh, no full-screen loader).
     Only that row fades out; totals and the free-shipping bar are updated from Shopify's own render. */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cart-remove]'); if (!b) return;
    if (!document.body.classList.contains('template-cart')) return;
    var sec = b.closest('.shopify-section'); if (!sec) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    var key = b.getAttribute('data-line'), sid = sec.id.replace('shopify-section-', '');
    var rows = Array.prototype.slice.call(sec.querySelectorAll('[data-item-row][data-line="' + key + '"]'));
    rows.forEach(function (r) { r.style.transition = 'opacity .2s'; r.style.opacity = '.35'; r.style.pointerEvents = 'none'; });
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0, sections: sid, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      try { sessionStorage.setItem('shubha_cart_count', String(cart.item_count)); } catch (err) {}
      var html = cart.sections && cart.sections[sid];
      if (!html) { window.location.reload(); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!cart.item_count) {
        var nc = doc.querySelector('#main-cart-items'), oc = sec.querySelector('#main-cart-items');
        if (nc && oc) oc.innerHTML = nc.innerHTML; else window.location.reload();
      } else {
        rows.forEach(function (r) { if (r.parentNode) r.parentNode.removeChild(r); });
        var nt = doc.querySelector('[data-cart-total]'), ot = sec.querySelector('[data-cart-total]');
        if (nt && ot) ot.innerHTML = nt.innerHTML;
        /* free-shipping bar: leave it as it is while the cart still qualifies (no restart animation) */
        var fsp = parseFloat(window.free_shipping_price || 0) * 100;
        if (fsp && cart.total_price < fsp) { var nb = doc.querySelector('.cart-message'), ob = sec.querySelector('.cart-message'); if (nb && ob) ob.innerHTML = nb.innerHTML; }
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }).catch(function () { window.location.reload(); });
  }, true);

  /* cart panel + cart page: the changed product fades while Shopify updates it (no full reload look) */
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#halo-cart-sidebar [data-cart-remove], #halo-cart-sidebar [data-minus-quantity-cart], #halo-cart-sidebar [data-plus-quantity-cart], .template-cart [data-minus-quantity-cart], .template-cart [data-plus-quantity-cart]');
    if (!b) return;
    var row = b.closest('.sc-item, .previewCartItem, [data-item-row]');
    if (row) row.classList.add('sh-busy-row');
  }, true);
})();
